import { useEffect, useState } from "react";
import Modal from "../../layout/Modal";
import Button from "../../layout/Button";
import { AudioSelector } from "../../audioSelection/audioSelector";
import useFormValidation from "../../../hooks/formValidation";
import { AudioMessage, IvrMenuNode, Queue } from "../../../model/queue.model";

function MenuNodeMessageModal({
  shown,
  node,
  path,
  queues,
  onClose,
  onSave,
}: MenuNodeMessageModalProps) {
  const labels = node.options.map((o) => ({ option: o.option, name: o.name }));
  const [message, setMessage] = useState<AudioMessage>();
  const [customError, setCustomError] = useState(false);
  const [error, setError] = useState<AudioMessage>();

  const formValidation = useFormValidation();

  useEffect(() => {
    if (!shown) return;
    setMessage(node.message);
    setCustomError(!!node.error);
    setError(node.error);
  }, [shown, node]);

  const onCloseHandler = () => {
    onClose();
  };

  const saveHandler = () => {
    if (!formValidation.validateForm()) return;
    onSave(message, customError ? error : undefined);
  };

  return (
    <Modal
      title="Mensagem deste nível"
      className="w-[600px]"
      shown={shown}
      onClose={onCloseHandler}
    >
      <div className="mb-6">
        <AudioSelector
          id="greeting"
          title="Mensagem de Saudação e Opções"
          description={
            <p className="text-gray-dark text-xs 2xl:text-base mb-4">
              Tocada quando o cliente chega neste nível do menu. Deve incluir
              as opções deste submenu.
            </p>
          }
          value={message}
          setter={setMessage}
          useOptions
          path={path}
          options={labels}
          formValidation={formValidation}
          queues={queues}
          required
        />
      </div>

      <div className="mb-2">
        <label className="flex items-center gap-2 text-xs 2xl:text-sm font-bold text-gray-dark cursor-pointer">
          <input
            type="checkbox"
            checked={customError}
            onChange={(e) => setCustomError(e.target.checked)}
          />
          Personalizar mensagem de opção inválida neste nível
        </label>
        {!customError && (
          <div className="text-gray-dark text-xs mt-1">
            Sem personalização, este nível usa a mensagem de erro do nível
            anterior.
          </div>
        )}
      </div>

      {customError && (
        <div className="mb-6">
          <AudioSelector
            id="error"
            title="Mensagem de Opção Inválida"
            description={
              <p className="text-gray-dark text-xs 2xl:text-base mb-4">
                Tocada quando o cliente digita uma opção que não existe
                neste nível, ou não digita nada.
              </p>
            }
            value={error}
            setter={setError}
            useOptions={false}
            path={path}
            formValidation={formValidation}
            queues={queues}
            required
          />
        </div>
      )}

      <div>
        <Button color="purple" className="float-right" onClick={saveHandler}>
          Salvar
        </Button>
      </div>
    </Modal>
  );
}

export default MenuNodeMessageModal;

export type MenuNodeMessageModalProps = {
  shown: boolean;
  node: IvrMenuNode;
  path: number[];
  queues: Queue[];
  onClose: () => void;
  onSave: (message: AudioMessage, error: AudioMessage | undefined) => void;
};
